import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=4fe23269&scoped=true&"
import script from "./Billing.vue?vue&type=script&lang=ts&"
export * from "./Billing.vue?vue&type=script&lang=ts&"
import style0 from "./Billing.vue?vue&type=style&index=0&id=4fe23269&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe23269",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VAlert,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe23269')) {
      api.createRecord('4fe23269', component.options)
    } else {
      api.reload('4fe23269', component.options)
    }
    module.hot.accept("./Billing.vue?vue&type=template&id=4fe23269&scoped=true&", function () {
      api.rerender('4fe23269', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/tabs/Billing.vue"
export default component.exports